import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import RichTextPreview from './RichTextPreview';

type IProps = {
  value: string;
  textStyle?: 'headingTitle' | 'textBody';
  title?: string;
};

export const RichTextDisplay: React.FC<IProps> = ({
  value,
  textStyle,
  title
}) => {
  return (
    <Flex flexDirection={'column'}>
      {title && (
        <Flex flexDirection={'column'}>
          <Flex flexDirection={'row'} gap={2}>
            <Text textStyle="headingItem">{title}</Text>
          </Flex>
        </Flex>
      )}
      <Box textStyle={textStyle ?? 'textBody'}>
        <RichTextPreview value={value} />
      </Box>
    </Flex>
  );
};
